import React from 'react';
import { Link } from 'react-router-dom';
import { buttonReset, color, font, space, TAP, weight } from '../theme';
import { NavState } from '../layout/CardLink';
import Icon from './Icon';

/* "● 12 במשכן עכשיו ›" above a list whose photos carry presence dots: the legend for the
   dot, and the way to the במשכן tab. Lists show it only when someone on them is inside. */
interface PresenceLegendProps {
  count: number;
  // e.g. "שרים" → "3 שרים במשכן עכשיו"
  noun?: string;
  to?: string;
  state?: NavState;
  onClick?: () => void;
}

const PresenceLegend = ({ count, noun, to, state, onClick }: PresenceLegendProps) => {
  const style: React.CSSProperties = {
    ...buttonReset,
    alignSelf: 'flex-start',
    minHeight: TAP,
    display: 'inline-flex',
    alignItems: 'center',
    gap: space.xs + 2,
    fontSize: font.small,
    fontWeight: weight.medium,
    color: color.primary,
    textDecoration: 'none',
  };
  const content = (
    <>
      <span aria-hidden="true" style={{ width: 9, height: 9, borderRadius: '50%', background: color.present, flexShrink: 0 }} />
      {count}{noun ? ` ${noun}` : ''} במשכן עכשיו
      <Icon name="chevronForward" size={16} />
    </>
  );
  if (to) return <Link to={to} state={state} style={style}>{content}</Link>;
  return <button type="button" onClick={onClick} style={style}>{content}</button>;
};

export default PresenceLegend;
